//deps
import React, { memo, ReactElement } from "react";
import cx from "classnames";

//widgets
import { SwiggyMoneyInfo } from "@payment-ui/widgets/index";

//interface
import {
    ViolationType,
    SwiggyMoneyInfoHalfCardModel,
    ViolationState,
    SwiggyMoneyInfoActions,
} from "@payment-ui/interfaces";

// test-ids
import { ADD_SWIGGY_MONEY_TEST_IDS } from "@swiggy-private/payment-test-ids";

import styles from "../styles.v4.scss";

interface ViolationMessageProps {
    swiggyMoneyInfoHalfCard?: SwiggyMoneyInfoHalfCardModel;
    violation: ViolationState;
    actions: SwiggyMoneyInfoActions;
}

function ViolationMessage({ swiggyMoneyInfoHalfCard, actions, violation }: ViolationMessageProps): ReactElement {
    const showWarning = violation.type == ViolationType.WARNING;
    const showError = violation.type == ViolationType.ERROR;

    const canShowViolationMessage = (showWarning || showError) && violation.message.length;

    const violationClass = cx(styles.violationContainer, {
        [styles.violationError]: showError,
        [styles.violationWarning]: showWarning,
        [styles.violationAnimation]: canShowViolationMessage,
    });

    return (
        <div data-testid={ADD_SWIGGY_MONEY_TEST_IDS.AMOUNT_SELECTION_INPUT_ERROR} className={violationClass}>
            {violation.message.length ? (
                <SwiggyMoneyInfo
                    info={violation.message}
                    swiggyMoneyInfoHalfCardDetails={swiggyMoneyInfoHalfCard}
                    canShowSwiggyMoneyInfoCta={violation.showSwiggyMoneyInfoHalfCard}
                    swiggyMoneyInfoCtaClassName={styles.swiggyMoneyInfoCta}
                    infoClassName={styles.swiggyMoneyInfoMessage}
                    actions={actions}
                />
            ) : null}
        </div>
    );
}

export default memo(ViolationMessage);
